import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid, Row, Col } from 'react-flexbox-grid';

import FormField from 'containers/FormField';
import LikertField from 'components/LikertField';

import FormProvider from 'routes/Documents/containers/FormProvider';
import InfoField from 'routes/Documents/components/InfoField';

import { msisSection, msisWrapper, padded, oddSection, evenSection } from './Scores.less';

import MSNQSections from '../MSNQSections';
import { nowPartialDate } from 'neuro-utils';

const MSNQForm = props => {
  // Effect to set 'date' field as current date in partial form when creating a new MSNQ form
  React.useEffect(() => {
    if (!props.formValues.date && props.editing && Object.keys(props.initialValues).length === 0) {
      props.change('date', nowPartialDate());
    }
  }, []);

  return (
    <FormProvider {...props}>
      <InfoField>
        <Grid fluid>
          <Row className={padded}>
            <Col xs>
              <h6>
                <b>
                  <FormattedMessage id="msnq.instructions.part1" />{' '}
                </b>
                <FormattedMessage id="msnq.instructions.part2" />
                <b>
                  <FormattedMessage id="msnq.instructions.part3" />
                </b>
                <FormattedMessage id="msnq.instructions.part4" />
                <b>
                  <FormattedMessage id="msnq.instructions.part5" />
                </b>
              </h6>
            </Col>
          </Row>
          <Row>
            <Col xs>
              <h6>
                <FormattedMessage id="msnq.instructions.part6" />
              </h6>
            </Col>
          </Row>
        </Grid>
      </InfoField>
      <div className={msisWrapper}>
        {MSNQSections.map((msnqs, i) => (
          <div key={`msnq_${msnqs}`} className={i % 2 === 0 ? oddSection : evenSection}>
            <Grid fluid className={msisSection}>
              <Row middle="xs">
                <Col xs={5}>
                  <h6>
                    <FormattedMessage id={`msnq.section.${msnqs}`} />
                  </h6>
                </Col>
                <Col xs={7}>
                  <FormField
                    name={msnqs}
                    component={LikertField}
                    max={5}
                    minLabel="msnq.label.veryOften"
                    maxLabel="msnq.label.never"
                    startFromZero
                    invertedScale
                    allLabels={[
                      'msnq.label.veryOften',
                      'msnq.label.quiteOften',
                      'msnq.label.occasionally',
                      'msnq.label.veryRarely',
                      'msnq.label.never',
                    ]}
                  />
                </Col>
              </Row>
            </Grid>
          </div>
        ))}
      </div>
    </FormProvider>
  );
};

export default MSNQForm;
